module.exports = __webpack_public_path__ + "images/icon5.svg";